// frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Importe suas páginas aqui (elas ainda não existem, vamos criá-las)
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import ProductsPage from './pages/ProductsPage';
import FinancialsPage from './pages/FinancialsPage';
import SettingsPage from './pages/SettingsPage'; // Para conectar Shopify
import SupplierPage from './pages/SupplierPage';
// import NotFoundPage from './pages/NotFoundPage';

// Importe o Layout Principal (ainda não existe)
import MainLayout from './layouts/MainLayout';

// Importe um componente para proteger rotas (ainda não existe)
import ProtectedRoute from './components/ProtectedRoute';

// Componentes Placeholder temporários
// const LoginPage = () => <div className="p-4">Página de Login (Placeholder)</div>;
// const RegisterPage = () => <div className="p-4">Página de Registro (Placeholder)</div>;
// const DashboardPage = () => <div className="p-4">Dashboard (Placeholder)</div>;
// const ProductsPage = () => <div className="p-4">Produtos (Placeholder)</div>;
// const FinancialsPage = () => <div className="p-4">Financeiro (Placeholder)</div>;
// const SettingsPage = () => <div className="p-4">Configurações Shopify (Placeholder)</div>;
const NotFoundPage = () => <div className="p-4">404 - Página Não Encontrada</div>;
// const MainLayout = ({ children }) => <div className="min-h-screen bg-blue-100"><nav className="bg-blue-500 p-4 text-white">Navbar (Layout)</nav><main>{children}</main></div>; // Placeholder
// const ProtectedRoute = ({ children }) => {
//     // Lógica de verificação de autenticação (vamos implementar depois com Context)
//     const isAuthenticated = !!localStorage.getItem('user'); // Exemplo básico
//     console.log("ProtectedRoute check:", isAuthenticated);
//     return isAuthenticated ? children : <Navigate to="/login" replace />;
// };


function App() {
  return (
    <Router>
      <Routes>
        {/* Rotas Públicas */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Rotas Privadas (dentro do Layout Principal) */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard" // Redundante com '/', mas pode ser explícito
          element={
            <ProtectedRoute>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
         <Route
          path="/products"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ProductsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
         <Route
          path="/financials"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FinancialsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
         <Route
          path="/settings" // Para conectar Shopify
          element={
            <ProtectedRoute>
              <MainLayout>
                <SettingsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route path="/supplier/:token" element={<SupplierPage />} />

        {/* Rota Catch-all para 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;